import React from 'react';

export function IndexPage(): React.ReactElement {
  return <></>;
}
